import { proxy, useSnapshot } from "valtio";
import { fetchCampaign } from "v2/api/coral";

interface CoralCampaign {
  campaign: {
    id: number;
    commissionValue: string;
  };
}

const coralCampaign = proxy<CoralCampaign>();

export async function loadCoralCampaign() {
  const rawCoralCampaign = await fetchCampaign();

  coralCampaign.campaign = {
    id: rawCoralCampaign.id,
    commissionValue: rawCoralCampaign.commission_value,
  };
}

export function useCoralCampaign() {
  return useSnapshot(coralCampaign.campaign);
}
